// tslint:disable: variable-name
export enum WizardType {
  FirstTimeRegistration = 0,
  QuickRegistration = 1,
  PartnerRegistration = 2,
  NewMemberRegistration = 3,
  SocialRegistration = 4,
  GuardianRegistration = 5,
  AccountActivation = 6,
  ReferAFriend = 7,
  NoIpid = 8,
  ChildRegistration = 9,
  External = 10,
  InPark = 11,
  UpgradeMembership = 12,
  AccountVerification = 13,
}
